import { IAppReduxState } from 'shared/types/app';

export function selectIsOpen(state: IAppReduxState): boolean {
  return state.ReloadPage.isOpen;
}

export function selectModalTitle(state: IAppReduxState): string {
  return state.ReloadPage.title;
}
